/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt, showModal, arrayFrom, getServerTime, } from '../../twd'
import { formatStatus } from './format-status'

export const Body = ({rows, shown, setShown}) => {

    return <tbody>
        {rows.map((r,i) => {
            const isAuction = String(r.propTransNetMoneyStr).toLowerCase() === 'auction'

            return <React.Fragment key={`orders-blotter-${i}`}>
            <tr>
            <td>{r.tradeNum}</td>
            <td className='text-center'>{formatTradeActions(r)}</td>
            <td>{r.tradeStatus}</td>
            <td style={{whiteSpace:'nowrap'}}>{formatDateTime(r.tradeSubmitDateAts) || r.tradeSubmitDate}</td>
            <td>{formatTradeType(r)}</td>
            <td className="text-right">{fmt.qty(r.tradeQtyBond)}</td>
            <td><div>{fmt.issuer({
                    issuer:r.holdIssue,
                    cusip: arrayFrom(r.holdCusip).join(''),
                    showBondDetail: 'Y',
                    isTreasuryAuction: isAuction,
                    from:'orders'
                })}
                </div>
                <div><label className="label-small"
                    style={{whiteSpace:'normal'}}
                    dangerouslySetInnerHTML={{__html:fmt.warningText(r.holdWarningText)}}
                ></label>
                </div>
                {['A','C','M'].indexOf(r.holdInvType.join(''))>=0
                    ? <button
                        data-name="trade-history-link"
                        className="btn-link"
                        onClick={(e) => {
                            showModal({
                                view: 'trade-history',
                                cusip: r.holdCusip,
                                source: e.target,
                            })
                        }}
                        >Trade history</button>
                    : null
                }
            </td>
            <td>{r.holdCusip}</td>
            <td><div>{formatCoupon(r)}</div><div>{r.holdMaturity}</div></td>
            <td className="text-right">{isAuction
                ? 'Auction'
                : <React.Fragment>
                    <div>{fmt.price3N(r.tradeFilledPx)}</div>
                    <div>{fmt.ytw3(r.tradeFilledYtw)}</div>
                    {r.tradeFilledDiscount ? <React.Fragment><div>{fmt.ytw3(r.tradeFilledDiscount)}&nbsp;({r.holdYieldInd})</div></React.Fragment> : null}
                </React.Fragment>
            }</td>
            <td className="text-nowrap">{r.acctNo}</td>
            <td>{r.tradeSubmitByName}</td>
            <td className="text-right">{isAuction ? 'Auction' : fmt.money(r.propTransNetMoney)}</td>
            </tr>

            {formatStatus({ rec:r, ...r, shown, setShown})}

            </React.Fragment>
        })}
    </tbody>
}

const formatDateTime = (ts) => {
    if (!ts) return null
    const dt = new Date(ts)
    if (isNaN(dt)) return null

    const tm = getServerTime(dt)
    return <React.Fragment>
        <div>{fmt.mdy(tm)}</div>
        <div>{fmt.fmtDt(tm, 'hh:mm:ss a').toLowerCase()}</div>
    </React.Fragment>
}

const formatTradeActions = ({tradeActions, tradeNum:orderNo}) => {
    const acts = tradeActions.split(',')
    const action = acts.indexOf('cancel')>=0
        ? 'Cancel'
        : 'View'
    return <button
        data-name="trade-detail-button"
        className="btn-link"
        onClick={(e) => {
            showModal({
                view: 'order-detail',
                action: action.toLowerCase(),
                orderNo,
                source: e.target,
            })
        }}
    >{action}</button>
}


const tradeTypeMap = {
    'Offer-W': {label:'Offer Quote Request', color:'green'},
    'Buy': {color:'green'},
    'Bid-W': {label:'Bid Quote Request', color:'red'},
    'Sell': {color:'red'},
}

const formatTradeType = ({tradeType}) => {
    const a = tradeTypeMap[tradeType] || {color:'#242424'}
    return <span style={{color:a.color}}>{a.label || tradeType}</span>
}

const formatCoupon = ({holdCoupon, holdCouponTypeCode, holdCouponFixedToFloat}) => {
    let isFLT = holdCouponTypeCode==='E'
    let isF2F = holdCouponFixedToFloat==='Y'

    if (isFLT) {
        return !isF2F
            ? 'FLT'
            : <React.Fragment>{fmt.cpn(holdCoupon)} F2F</React.Fragment>
    }
    return fmt.cpn(holdCoupon)
}